import DatePicker from 'react-datepicker';
import React, { ForwardedRef, forwardRef, useState } from 'react';
import { Calendar } from 'react-feather';
import classNames from 'classnames';
import moment from 'moment';

const DEFAULT_DISPLAY_FORMAT = 'dd MMM yyyy';
const DEFAULT_INPUT_FORMAT = 'YYYY-MM-DD';

type CalenderInputProps = {
  startDate?: Date;
  dateFormat?: string;
  inputDateFormat?: string;
  className?: string;
  showMonthYearPicker?: boolean;
  datepickerWidth?: number;
  minDate?: Date;
  maxDate?: Date;
  datepicker?: boolean;
  value?: string | null;
  placeholderText?: string;
  disabled?: boolean;
  onChangeHandler: (date) => void;
};

interface InputFieldProps {
  value?: string;
  onClick?: () => void;
  datepickerWidth: any;
  datepicker?: boolean;
  placeholderText?: string;
  disabled?: boolean;
}

export const InputField = forwardRef(
  ({ value, onClick, datepicker, placeholderText, disabled }: InputFieldProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <div className={classNames('crt-datepicker-field', { 'crt-input-picker': datepicker })}>
        <input disabled={disabled} placeholder={placeholderText} type="text" className="form-control" ref={ref} value={value} onClick={onClick} readOnly />
        <Calendar />
      </div>
    );
  },
);
InputField.displayName = 'InputField';

export const CalenderInput = ({
  startDate,
  dateFormat,
  inputDateFormat,
  className,
  showMonthYearPicker,
  datepickerWidth,
  minDate,
  maxDate,
  datepicker = false,
  value,
  onChangeHandler,
  placeholderText,
  disabled,
}: CalenderInputProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const format = datepicker ? dateFormat || DEFAULT_DISPLAY_FORMAT : dateFormat;
  const inputFormat = datepicker ? inputDateFormat || DEFAULT_INPUT_FORMAT : undefined;
  const defaultPlaceholderText = datepicker ? 'DD MMM YYYY' : undefined;

  const parseDate = value ? moment(value, inputFormat).toDate() : undefined;

  const onChangeInput = (date) => {
    setIsOpen(!isOpen);

    if (datepicker) {
      onChangeHandler(moment(date).format(inputFormat));
    } else {
      onChangeHandler(date);
    }
  };

  return (
    <>
      <DatePicker
        onChange={(date) => onChangeInput(date)}
        dateFormat={format}
        selected={datepicker ? parseDate : startDate}
        showMonthYearPicker={showMonthYearPicker}
        className={classNames(className)}
        calendarClassName={classNames('crt-datepicker', { 'crt-day-picker': datepicker }, className)}
        customInput={<InputField disabled={disabled} placeholderText={defaultPlaceholderText} datepickerWidth={datepickerWidth} datepicker={datepicker} />}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={defaultPlaceholderText}
        disabled={disabled}
      />
    </>
  );

  /* return (
    <>
      <div className="calender-input">
        <div
          className="d-flex justify-content-between form-control"
          onClick={() => setIsOpen(!isOpen)}
          style={{ width: datepickerWidth }}
        >
          <div className="align-self-center " onBlur={() => setIsOpen(!isOpen)}>
            {moment(startDate).format('MMM-yyyy')}
          </div>
          <Calendar className="align-self-center" />
        </div>
        {isOpen && (
          <div className="">
            <DatePicker
              selected={startDate}
              inline
              onChange={(date) => onChangeInput(date)}
              dateFormat={dateFormat}
              showMonthYearPicker={showMonthYearPicker}
              className={classNames(className)}
              calendarClassName="crt-datepicker"
            />
          </div>
        )}
      </div>
    </>
  ); */
};
